export default {
  report_id_label: "報告 ID",
  report_id_placeholder: "輸入報告 ID 進行搜尋",
  type_label: "類型",
  type_placeholder: "選擇類型",
  shared_label: "已分享",
  shared_placeholder: "選擇分享狀態",
  report_id: "報告 ID",
  date: "日期",
  report_type: "報告類型",
  created_at: "建立時間",
  shared: "已分享",
  actions: "操作",
  view_count: "瀏覽次數",
  regenerate: "重新生成",
  delete_confirm: "確定要刪除此報告嗎？",
  copied: "連結已複製到剪貼簿",
  copied_with_expire: "連結已複製到剪貼簿，將於 {date} 到期",
  copy_failed: "複製連結失敗",
  share_failed: "分享失敗",
  report_detail: "報告詳情",
  preview_title: "報告預覽",
  data_format_error: "數據格式錯誤",
  plan_changed_notice: "您的方案已變更，現在使用最新的方案 ({planType}) 顯示此報告。",
  config_changed_notice: "您的設定已變更，現在使用最新的設定顯示此報告。",
  calculation_deleted_notice: "部分計算已被刪除。",
  delete_success: "刪除成功",
  not_found_title: "找不到報告",
  not_found_desc: "您查找的報告不存在",
  share: "分享",
  copy_link: "複製連結",
  share_to_x: "分享到 X",
  share_to_linkedin: "分享到 LinkedIn",
  unshare: "取消分享",
  unshare_success: "報告取消分享成功",
  unshare_failed: "報告取消分享失敗",
  shared_expires_at: "分享到期時間",
  privacy_fields_hidden: "隱私欄位預設隱藏，可在設定 - 報告設定中修改，變更立即生效",
  want_to_calculate: "想要計算您自己的 CBAM 碳稅報告嗎？首次計算後可獲得 50 次計算機會",
  register_free: "免費註冊",
  use_invitation_code: "使用邀請碼",
  failed_to_load_shared_report: "載入分享報告失敗",
  report_data_missing: "報告數據缺失",
  unable_to_get_shared_report: "無法獲取分享報告數據",
  carbon_emission_report: "碳排放報告",
  check_out_carbon_emission: "查看此碳排放報告",
};
